// Imports


// Plugins
const plugins = [{
  location: "/opt/build/repo/node_modules/react-static-plugin-styled-components",
  plugins: [],
  hooks: {}
},
{
  location: "/opt/build/repo",
  plugins: [],
  hooks: {}
}]

// Export em!
export default plugins